export { default } from './Zoom';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Zoom/index.js
// module id = 818
// module chunks = 121